import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { getTextOverflowProps, KeyPointList } from '../../pages/pro/Listing/components/helper';

interface Props {
  expert: any;
  project?: any;
  showProjectSpecific?: boolean;
  showHeader?: boolean;
  parentRef?: React.RefObject<HTMLDivElement>;
  defaultHeight?: number;
}

export const ExpertKeyPointsList: React.FC<Props> = ({
  expert,
  project,
  showProjectSpecific = false,
  showHeader = true,
  parentRef,
  defaultHeight = 80,
}) => {
  let keyPoints = expert?.keyPoints || [];
  
  if (project && expert?.projectKeyPoints?.length > 0) {
    keyPoints = expert.projectKeyPoints.map((point: any) => ({
      keyPoint: point.key_point,
    }));
  }

  if (!keyPoints || keyPoints.length === 0) {
    return null;
  }

  const panelHeight = useMemo(() => {
    let height = defaultHeight;
    if (parentRef?.current?.clientHeight) {
      height = 360 - Math.min(parentRef?.current?.clientHeight, 300);
    }
    return height;
  }, [parentRef, defaultHeight]);

  return (
    <Box className="flex flex-col gap-1 mt-[8px]">
      {showHeader && (
        <Typography
          variant="body2"
          color="var(--text-2)"
          className="font-medium"
        >
          Key Points
        </Typography>
      )}
      <div className='overflow-y-auto pr-2' style={{ height: panelHeight }}>
        <KeyPointList>
          {keyPoints.map((point: any, index: number) => (
            <li
              key={`${point.keyPoint}-${index}`}
              style={{
                listStyle: 'none',
                marginBottom: '0.25rem',
                fontSize: '12px',
                lineHeight: '1.3',
                color: 'var(--text-2)',
                fontFamily: 'CircularStd',
                fontWeight: 450,
              }}
            >
              {point.keyPoint}
            </li>
          ))}
        </KeyPointList>
      </div>
    </Box>
  );
};

export const ExpertKeyPoints: React.FC<Props> = ({
  expert,
  project,
  showProjectSpecific = false,
  showHeader = true,
}) => {
  let keyPoints = expert?.keyPoints || [];
  
  if (showProjectSpecific && project && expert?.projectKeyPoints?.length > 0) {
    keyPoints = expert.projectKeyPoints.map((point: any) => ({
      keyPoint: point.key_point,
    }));
  }

  if (showProjectSpecific && (!keyPoints || keyPoints.length === 0)) {
    return null;
  }

  return (
    <Box className="flex flex-col gap-1">
      {showHeader && (
        <Typography
          variant="body2"
          color="var(--text-2)"
          className="font-medium"
        >
          Key Points
        </Typography>
      )}
      <ExpertKeyPointsList
        expert={expert}
        project={project}
        showProjectSpecific={showProjectSpecific}
        showHeader={false}
      />
    </Box>
  );
}; 